<script lang="ts">
    import Clock from './clock.svelte';
    import GameSessionTime from './game-session-time.svelte';

    const titleGame = document.title;
</script>

<div
    class="adaptive-px justify-space-between pointer-events-none absolute left-0 top-0 z-[9000] flex h-4 w-full items-center bg-black/[.48] font-Roboto text-xxs text-white desktop:z-9000 desktop:h-10 desktop:bg-transparent desktop:text-md"
>
    <div>{titleGame}</div>
    <div class="ml-auto flex items-center justify-center gap-2">
        <Clock format="HH:mm" />|<GameSessionTime />
    </div>
</div>
